'use client';

import type { DenormalizedCreationState } from '@pixum/types';
import { CreationThumbnail } from 'components';
import styles from '../ArticlePreviewControl.module.css';

export interface ArticlePreviewThumbnailProps {
  previewUrl: string;
  creation?: DenormalizedCreationState | null;
  alt: string;
  isInactive?: boolean;
  width?: number;
  height?: number;
}

export function ArticlePreviewThumbnail({
  previewUrl,
  creation,
  alt,
  isInactive = false,
  width = 164,
  height = 164,
}: ArticlePreviewThumbnailProps) {
  const containerClass = [
    styles['imageContainer'],
    isInactive ? styles['isInactive'] : '',
  ].filter(Boolean).join(' ');

  return (
    <span className={containerClass}>
      <CreationThumbnail
        creation={creation}
        previewUrl={previewUrl}
        alt={alt}
        width={width}
        height={height}
      />
    </span>
  );
}
